<template>
  <div>
    <el-row>
      <el-button type="primary" @click="add">新增</el-button>
      <el-input v-model="search" placeholder="搜索" style="width: 300px;float: right">
        <el-button slot="append" icon="el-icon-search" @click="getEventSubscribeList"></el-button>
      </el-input>
    </el-row>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="createTime" label="创建时间" >
        <template slot-scope="scope">
          {{ new Date(scope.row.createTime * 1000).Format('yyyy-MM-dd hh:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="更新时间" >
        <template slot-scope="scope">
          {{ new Date(scope.row.updateTime * 1000).Format('yyyy-MM-dd hh:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="appkey" label="appKey" ></el-table-column>
      <el-table-column align="center" prop="eventNameDtoList" label="事件列表">
        <template scope="scope">
          <el-popover
            placement="right-start"
            width="400"
            trigger="click">
            <el-table :data="scope.row.eventNameDtoList" height="200px">
              <el-table-column  label="事件ID" align="center" prop="eventId"></el-table-column>
              <el-table-column  label="事件名称" align="center" prop="eventName"></el-table-column>
            </el-table>
            <el-button slot="reference" size="mini">点击查看事件列表</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="callbackAddr" label="回调地址"></el-table-column>
      <el-table-column align="center" label="操作" width="300">
        <template v-slot="{row}">
          <!--          <el-tooltip class="item" effect="light" content="编辑" placement="top-start">-->
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="getEventSubscribe(row)"></el-button>
          <!--          </el-tooltip>-->
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="delConfirm(row)"></el-button>
          <el-button v-if="row.statusFlag==0"
            type="success" icon="el-icon-switch-button" size="mini" @click="openOrClose(row,'1')"></el-button>
          <el-button v-else type="danger" icon="el-icon-caret-right" size="mini" @click="openOrClose(row,'0')"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
    <el-dialog :title="subscribeTitle" :visible.sync="subscribeVisible" width="400px">
      <el-form :model="addForm" ref="addForm" :rules="rules">
        <el-form-item label="appKey" label-width="80px" prop="appKey">
          <el-input v-model="addForm.appKey" style="width:220px"></el-input>
        </el-form-item>
        <el-form-item label="事件列表" label-width="80px" prop="event">
          <el-select v-model="addForm.event" multiple filterable  collapse-tags>
            <el-option v-for="(item, index) in eventList"
                       :key="index"
                       :label="item.eventName"
                       :value="item.eventId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回调地址" label-width="80px" prop="addr">
          <el-input v-model="addForm.addr" style="width:220px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="addConfirm">确 定</el-button>
        <el-button @click="subscribeVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "EventSubscribe",
  data() {
    // let validateIP = (rule, value, callback) => {
    //   if(value && "..." === value){
    //     callback(new Error('请输入回调地址'))
    //   }if (value && !(/((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))/).test(value)) {
    //     callback(new Error('请输入正确的回调地址'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      subscribeTitle: "",
      tableData: [],
      subscribeVisible: false,
      eventData: [
        {
          date: "121"
        }
      ],
      addForm: {
        appKey: "",
        event: [],
        addr: "",
      },
      eventList: [],
      eventIDList: [],
      currentPage: 1,
      pageSize: 10,
      totalElement: 0,
      currentId: "",
      currentFlag: "",
      search: "",
      rules: {
        appKey: [
          {required: true, message: '请输入appKey', trigger: 'blur'},
        ],
        event: [
          {required: true, message: '请选择事件', trigger: 'change'},
        ],
        // addr: [
        //   { validator: validateIP, trigger: 'blur'},
        // ],
      }
    }
  },
  created() {
    this.getEventSubscribeList();
  },
  methods: {
    close() {
      this.subscribeVisible = false;
    },
    openOrClose(row, flag) {
      this.updateEventSubscribe(row, flag);
    },
    add() {
      this.subscribeTitle = "新增";
      this.addForm.appKey = "";
      this.addForm.event = [];
      this.addForm.addr = "";
      this.getEventList();
      this.subscribeVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getEventSubscribeList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getEventSubscribeList()
    },
    getEventList() {
      this.$axios
        .post(this.qoscountServerUrl + "eventSubscription/findEventList")
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.eventList = data;
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    getEventSubscribe(row) {
      this.getEventList();
      this.subscribeTitle = "编辑";
      this.addForm.appKey = row.appkey;
      this.addForm.event = row.eventList;
      this.addForm.addr = row.callbackAddr;
      this.subscribeVisible = true;
      this.currentId = row.id;
      this.currentFlag = row.statusFlag;
    },
    updateEventSubscribe(row,flag) {
      let obj = {}
      if (row) {
        obj = {
          id: row.id,
          eventList: row.eventList,
          appKey: row.appkey,
          callbackAddr: row.callbackAddr,
          statusFlag: parseInt(flag),
        }
      } else {
        obj = {
          id: this.currentId,
          eventList: this.addForm.event,
          appKey: this.addForm.appKey,
          callbackAddr: this.addForm.addr,
          statusFlag: this.currentFlag,
        }
      }
      this.$axios
        .post(this.qoscountServerUrl + "eventSubscription/update", obj)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.subscribeVisible=false;
            this.getEventSubscribeList()
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    getEventSubscribeList() {
      let obj = {
        startTime: 0,
        endTime: 0,
        appKey: "",
        condition: this.search,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$axios
        .post(this.qoscountServerUrl + "eventSubscription/findEventSubscriptionInfoByPage", obj)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.tableData = data.data;
            this.totalElement = data.total;
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    delConfirm(row){
      this.$confirm('是否确认删除该事件订阅？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delEventSubscribeList(row)
      }).catch(() => {

      });
    },
    delEventSubscribeList(row) {
      let obj = {
        id: row.id
      }
      this.$axios
        .post(this.qoscountServerUrl + "eventSubscription/delete", obj)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.getEventSubscribeList()
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    addEventSubscribe() {
      let obj = {
        appkey: this.addForm.appKey,
        eventList: this.addForm.event,
        callbackAddr: this.addForm.addr,
      }
      this.$axios
        .post(this.qoscountServerUrl + "eventSubscription/add", obj)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.subscribeVisible = false;
            this.getEventSubscribeList();
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    addConfirm() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (this.subscribeTitle == "编辑") {
            this.updateEventSubscribe()
          } else {
            this.addEventSubscribe()
          }
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
